import React from 'react';
import i18next from 'i18next';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { request } from '@api/request-with-tokens';
import { WidgetLoginButton } from '../atoms';
import { Modal, withModals } from '../../common/organisms';
import { FormEntryModal } from '../organisms/form-entry-modal';

const enchance = compose(
  withState('entryFormStep', 'setEntryFormStep', 'login'),
  withState('redirectLink', 'setRedirectLink', `/${window._lang}/cabinet`),
  withModals(['formEntry']),
  withHandlers({
    onOpen: ({ entryFormStep }) => () => {
      const form = new window.POPFormEntry();
      form.init({
        root: 'form-entry',
        mode: 'site',
        locale: window._lang,
      });

      form.open({
        initialStep: entryFormStep,
      });
    },

    onClickLogin: ({ setEntryFormStep, openModal }) => () => {
      setEntryFormStep('login');
      openModal('formEntry');
    },
  }),
  lifecycle({
    componentDidMount() {
      const { setEntryFormStep, setRedirectLink, openModal } = this.props;
      const hash = window.location.hash;
      const isRestore = hash === '#restore';
      const isSignup = hash === '#signup';

      if (isSignup) {
        setEntryFormStep('signup');
        openModal('formEntry');
      }

      if (isRestore) {
        setEntryFormStep('recovery_password');
        openModal('formEntry');
      }

      if (window.POPObserver) {
        const observer = new window.POPObserver();

        // хак для установки куки
        const onSetCookie = async () => {
          try {
            await request('get', `/${window._lang}/users/profile/`);
            window.location = this.props.redirectLink;
          } catch {
            window.location = `/`;
          }
        };

        observer.addEventListener('ON_SUCCESS_LOGIN', onSetCookie);
        observer.addEventListener('ON_CABINET', onSetCookie);
        observer.addEventListener('ON_RUN_STANDALONE', onSetCookie);
        observer.addEventListener('ON_OPEN_ENTRY_MODAL', ({ step, link }) => {
          setEntryFormStep(step);

          if (link) {
            setRedirectLink(link);
          }

          openModal('formEntry');
        });
      }
    },
  })
);

const LoginView = ({ modals, closeModals, onClickLogin, onOpen }) => (
  <>
    <WidgetLoginButton onClick={onClickLogin}>{i18next.t('Войти')}</WidgetLoginButton>
    <Modal isOpen={modals.formEntry.isOpen} closeModal={closeModals} onAfterOpen={onOpen}>
      <FormEntryModal />
    </Modal>
  </>
);

export const Login = enchance(LoginView);
